// src/Component/settings/ProfileSettings.js
import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../../apiClient';
import './ProfileSettings.css';

const ProfileSettings = ({ setMessage }) => {

  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    emailID: '',
    phoneNumber: '',
    password: '',
    role: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  // Fetch user profile
  const fetchUserProfile = useCallback(async () => {
    try {
      const { data } = await apiClient.get('/api/user-profile');

      setProfileData({
        firstName: data.firstName ?? '',
        lastName: data.lastName ?? '',
        emailID: data.emailID ?? '',
        phoneNumber: data.phoneNumber ?? '',
        password: '',
        role: data.role ?? '',
      });

    } catch (error) {
      setMessage({
        text: 'Failed to fetch user profile',
        type: 'error'
      });
    }
  }, [setMessage]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);


  // Handle change
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({ ...prev, [name]: value }));
  };


  // Submit profile
  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { data } = await apiClient.post('/api/update-profile', profileData);

      if (data.success) {
        setMessage({
          text: 'Profile updated successfully!',
          type: 'success'
        });

        // Clear password after save
        setProfileData(prev => ({ ...prev, password: '' }));
      }

    } catch (error) {
      setMessage({
        text: error.response?.data?.error || 'Failed to update profile',
        type: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="profile-tab">
      {/* <h2>Profile Settings</h2> */}

      <form className="profile-form" onSubmit={handleProfileSubmit}>

        <div className="form-grid">

          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              value={profileData.firstName}
              onChange={handleProfileChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={profileData.lastName}
              onChange={handleProfileChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="emailID"
              value={profileData.emailID}
              onChange={handleProfileChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              name="phoneNumber"
              value={profileData.phoneNumber}
              onChange={handleProfileChange}
            />
          </div>

          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              name="password"
              value={profileData.password}
              onChange={handleProfileChange}
              placeholder="Leave blank to keep current password"
            />
          </div>

          <div className="form-group">
            <label>Role</label>
            <input
              type="text"
              name="role"
              value={profileData.role}
              disabled
              className="readonly"
            />
          </div>

        </div>

        <button
          type="submit"
          className="save-btn"
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : 'Save Profile'}
        </button>

      </form>
    </div>
  );
};

export default ProfileSettings;
